// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-list {
  --light-gray: rgb(241, 241, 241);
  height: 100vh;
  width: 100%;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}
.schedule-list ::-webkit-scrollbar {
  height: 8px;
  width: 0px;
}
.schedule-list .event-list-header {
  position: relative;
  scroll-behavior: smooth;
  margin-bottom: 8px;
  margin-left: 4px;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  overflow-x: auto;
}
.schedule-list .event-list-header .event-day-label:first-child {
  border-radius: var(--border-radius) 0 0 var(--border-radius);
}
.schedule-list .event-list-header .event-day-label:last-child {
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}
.schedule-list .event-list-header .event-day-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  color: rgb(126, 126, 126);
  background-color: var(--light-gray);
  border: 1px solid white;
  padding: 14px 6px 10px 6px;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
}
.schedule-list .event-list-header .day-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 4px;
}
.schedule-list .event-list-header .day-subtitle {
  text-transform: uppercase;
}
.schedule-list .event-list-header .active-day {
  color: var(--motes-blue);
  background-color: rgb(233, 233, 233);
  border: none;
  box-shadow: inset 0 0 3px #464646;
}
.schedule-list .event-list-scroll {
  position: relative;
  scroll-behavior: smooth;
  display: block;
  overflow-y: auto;
  box-sizing: border-box;
}
.schedule-list .event-list-scroll .list-end-padding {
  height: 80%;
  width: 100%;
}
.schedule-list .event-day {
  margin-top: 10px;
  padding: 5px;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 1;
}
.schedule-list .event-day-title {
  font-size: 18px;
}
.schedule-list .event {
  display: flex;
  flex-direction: row;
  height: 150px;
  color: black;
  background-color: #e2e2e2;
  border: 1px solid white;
  border-radius: var(--border-radius);
  box-sizing: border-box;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
}
.schedule-list .event .event-content {
  padding: 12px;
  flex-grow: 1;
  /** Ensure that white-space: nowrap does not mess up flex layout */
  min-width: 0;
  /** Hide event date on small screens **/
}
@media (max-width: 400px) {
  .schedule-list .event .event-content .event-date {
    display: none;
  }
}
.schedule-list .event .event-image {
  height: 100%;
  width: auto;
}
.schedule-list .event .event-title {
  font-weight: bold;
}
.schedule-list .event .event-info-row {
  width: 100%;
  max-width: 100%;
  vertical-align: bottom;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 6px;
  white-space: nowrap;
}
.schedule-list .event .event-info-row svg-icon {
  margin-right: 8px;
}
.schedule-list .event .event-preview {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
.schedule-list .event.passed {
  background-color: #B1B1B1;
  border-color: #cacaca;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/schedule-list/schedule-list.component.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;EAEA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;AAEI;EACI,WAAA;EACA,UAAA;AAAR;AAGI;EACI,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADR;AAGQ;EACI,4DAAA;AADZ;AAIQ;EACI,4DAAA;AAFZ;AAKQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,uBAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAHZ;AAMQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;AAJZ;AAOQ;EACI,yBAAA;AALZ;AAQQ;EACI,wBAAA;EACA,oCAAA;EACA,YAAA;EACA,iCAAA;AANZ;AAUI;EACI,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EAGA,sBAAA;AAVR;AAYQ;EACI,WAAA;EACA,WAAA;AAVZ;AAcI;EACI,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAZR;AAeI;EACI,eAAA;AAbR;AAgBI;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EAEA,uBAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAfR;AAiBQ;EACI,aAAA;EACA,YAAA;EACA,kEAAA;EACA,YAAA;EACA,uCAAA;AAfZ;AAgBY;EAA4B;IAAc,aAAA;EAZpD;AACF;AAcQ;EACI,YAAA;EACA,WAAA;AAZZ;AAeQ;EACI,iBAAA;AAbZ;AAgBQ;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAdZ;AAgBY;EACI,iBAAA;AAdhB;AAkBQ;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,gBAAA;AAhBZ;AAoBI;EACI,yBAAA;EACA,qBAAA;AAlBR","sourcesContent":[".schedule-list {\n    --light-gray: rgb(241, 241, 241);\n    \n    height: 100vh;\n    width: 100%;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    box-sizing: border-box;\n\n    ::-webkit-scrollbar {\n        height: 8px;\n        width: 0px;\n    }\n    \n    .event-list-header {\n        position: relative;\n        scroll-behavior: smooth;\n        margin-bottom: 8px;\n        margin-left: 4px;\n        max-width: 100%;\n        display: flex;\n        flex-direction: row;\n        flex-shrink: 0;\n        overflow-x: auto;\n\n        .event-day-label:first-child {\n            border-radius: var(--border-radius) 0 0 var(--border-radius);\n        }\n     \n        .event-day-label:last-child {\n            border-radius: 0 var(--border-radius) var(--border-radius) 0;\n        }\n        \n        .event-day-label {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            min-width: 100px;\n            color: rgb(126, 126, 126);\n            background-color: var(--light-gray);\n            border: 1px solid white;\n            padding: 14px 6px 10px 6px;\n            box-sizing: border-box;\n            cursor: pointer;\n            user-select: none;\n            -webkit-user-select: none;\n        }\n\n        .day-title {\n            font-size: 28px;\n            font-weight: bold;\n            margin-bottom: 4px;\n        }\n\n        .day-subtitle {\n            text-transform: uppercase;\n        }\n\n        .active-day {\n            color: var(--motes-blue);\n            background-color: rgb(233, 233, 233);\n            border: none;\n            box-shadow:  inset 0 0 3px #464646;\n        }\n    }\n\n    .event-list-scroll {\n        position: relative;\n        scroll-behavior: smooth;\n        display: block;\n        overflow-y: auto;\n        // Add padding in bottom in order to scroll to last elements to top\n        // padding-bottom: 800px;\n        box-sizing: border-box;\n\n        .list-end-padding {\n            height: 80%;\n            width: 100%;\n        }\n    }\n\n    .event-day {\n        margin-top: 10px;\n        padding: 5px;\n        box-sizing: border-box;\n        flex-shrink: 0;\n        flex-grow: 1;\n    }\n    \n    .event-day-title {\n        font-size: 18px;\n    }\n\n    .event {\n        display: flex;\n        flex-direction: row;\n        height: 150px;\n        color: black;\n        background-color: #e2e2e2;\n \n        border: 1px solid white;\n        border-radius: var(--border-radius);\n        box-sizing: border-box;\n        margin-top: 10px;\n        overflow: hidden;\n        position: relative;\n\n        .event-content {\n            padding: 12px;\n            flex-grow: 1;\n            /** Ensure that white-space: nowrap does not mess up flex layout */ \n            min-width: 0;\n            /** Hide event date on small screens **/\n            @media (max-width: 400px) { .event-date { display: none; } }\n        }\n\n        .event-image {\n            height: 100%;\n            width: auto;\n        }\n\n        .event-title {\n            font-weight: bold;\n        }\n\n        .event-info-row {\n            width: 100%;\n            max-width: 100%;\n            vertical-align: bottom;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-bottom: 6px;\n            white-space: nowrap;\n\n            svg-icon {\n                margin-right: 8px;\n            }\n        }\n\n        .event-preview {\n            display: -webkit-box;\n            -webkit-line-clamp: 4;\n            -webkit-box-orient: vertical;\n            text-overflow: ellipsis;\n            overflow: hidden;\n        }\n    }\n\n    .event.passed {\n        background-color: #B1B1B1;\n        border-color: #cacaca;\n        .event-image {\n            // filter: grayscale(1);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
